function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0405 3.37378C14.431 2.98325 14.431 2.35009 14.0405 1.95956C13.6499 1.56904 13.0168 1.56904 12.6262 1.95956L8.00002 6.58579L3.37379 1.95956C2.98327 1.56904 2.3501 1.56904 1.95958 1.95956C1.56906 2.35009 1.56906 2.98325 1.95958 3.37378L6.58581 8L1.95958 12.6262C1.56906 13.0168 1.56906 13.6499 1.95958 14.0404C2.3501 14.431 2.98327 14.431 3.37379 14.0404L8.00002 9.41422L12.6262 14.0404C13.0168 14.431 13.6499 14.431 14.0405 14.0404C14.431 13.6499 14.431 13.0168 14.0405 12.6262L9.41423 8L14.0405 3.37378Z"
});

const SvgCloseSmall = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-small.9c179f50.svg";
export { ForwardRef as ReactComponent };